export const colors = {
  HIPAGES_ORANGE: `#F96F12`,
  HIPAGES_CHARCOAL: `#434447`,
  WARM_GREY: `#DDDCD1`,
  TEAL: '#00B9BD',
  BLUE_STEEL: '#3C8090',
  KAZOO: '#F96F12',
  MAROON: '#831C4B',
  DARK_GREY: '#2F3034',
  LIGHT_GREY: '#eee',
  ERROR_LIGHT: '#ffd6dc',
  GREY: '#aaa',
  WHITE: '#fff',
  RED: '#CA3121',
  MEDIUM_DARK_GREY: '#7B7C7E',
  FACEBOOK: '#4267b2',
  GREEN: '#71A643'
};

const fonts = {
  SANS_SERIF: 'Source Sans Pro',
  SERIF: 'Yrsa',
  ICONS: 'hui-icons'
};

export const Theme = {
  primary: colors.HIPAGES_ORANGE,
  secondary: colors.TEAL,
  secondaryDark: colors.BLUE_STEEL,
  body: colors.WARM_GREY,
  bodyFont: colors.DARK_GREY,
  back: colors.HIPAGES_CHARCOAL,
  dark: colors.HIPAGES_CHARCOAL,
  facebook: colors.FACEBOOK,
  muted: colors.GREY,
  defaultBackground: colors.LIGHT_GREY,
  dangerBackground: colors.ERROR_LIGHT,
  snow: colors.WHITE,
  success: colors.GREEN,
  notice: colors.HIPAGES_ORANGE,
  error: colors.RED,
  danger: colors.RED,
  fontDefault: fonts.SANS_SERIF,
  fontTitles: fonts.SERIF,
  fontIcons: fonts.ICONS,
  breakpoints: {
    xs: 0,
    sm: 30,
    md: 48,
    lg: 60
  }
};
